// front/src/pages/ProjectsPage.jsx
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBase = process.env.REACT_APP_API_URL || "";

  const loadProjects = async () => {
    try {
      const { data } = await axios.get(`${apiBase}/api/projects`, {
        withCredentials: true,
      });
      setProjects(data);
    } catch (err) {
      console.error("Error loading projects:", err);
      setError("Error loading projects");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProjects();
  }, []);

  if (loading) {
    return (
      <div className="container py-5">
        <p>Loading projects...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">My Programming Projects</h1>

      {projects.length === 0 && (
        <p className="text-muted">No projects available.</p>
      )}

      <div className="row g-4">
        {projects.map((p) => (
          <div key={p._id} className="col-md-4">
            <div className="card shadow-sm h-100">

              {/* Cover Image */}
              {p.coverImage?.url && (
                <img
                  src={p.coverImage.url}
                  className="card-img-top"
                  alt={p.title}
                  style={{ height: "200px", objectFit: "cover" }}
                />
              )}

              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{p.title}</h5>

                <p className="card-text" style={{ minHeight: "60px" }}>
                  {p.description?.length > 120
                    ? p.description.substring(0, 120) + "..."
                    : p.description}
                </p>

                {/* Tech Stack */}
                {p.techStack && p.techStack.length > 0 && (
                  <p className="small text-muted">
                    Tech: {p.techStack.join(", ")}
                  </p>
                )}

                {/* Gallery Thumbnails */}
                {p.galleryImages && p.galleryImages.length > 0 && (
                  <div className="mt-2 d-flex flex-wrap gap-2">
                    {p.galleryImages.slice(0, 3).map((img, i) => (
                      <img
                        key={img.publicId || i}
                        src={img.url}
                        alt=""
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                          borderRadius: "4px",
                          border: "1px solid #ddd",
                        }}
                      />
                    ))}

                    {p.galleryImages.length > 3 && (
                      <div
                        className="d-flex align-items-center justify-content-center bg-light border rounded"
                        style={{
                          width: "60px",
                          height: "60px",
                          fontSize: "0.8rem",
                          color: "#555",
                        }}
                      >
                        +{p.galleryImages.length - 3}
                      </div>
                    )}
                  </div>
                )}

                {/* Buttons */}
                <div className="mt-auto pt-3">
                  <Link
                    to={`/projects/${p._id}`}
                    className="btn btn-outline-primary btn-sm me-2"
                  >
                    View Details
                  </Link>

                  {p.githubUrl && (
                    <a
                      href={p.githubUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-dark btn-sm me-2"
                    >
                      GitHub
                    </a>
                  )}

                  {p.demoUrl && (
                    <a
                      href={p.demoUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-sm"
                    >
                      Live Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
